<template>
  <v-dialog  width="440px" v-model="dialog">
    <v-card height="280px">
      <v-card-text class="h-100">
        <v-layout row wrap class="h-100">
          <v-flex xs12 class="text-xs-center">
            <span class="title pa-0">
              Lista de espera por canal
            </span>
          </v-flex>
          <v-flex xs12>
            <v-list>
              <template v-for="(item, index) in channels">
                <v-list-tile :key="`channel-${index}`">
                  <v-list-tile-avatar>
                    <v-icon class="k-orange-linear-text">
                      {{icon(item.channel)}}
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{item.channel.charAt(0).toUpperCase() + item.channel.slice(1)}}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar>
                    {{item.quantity}}
                  </v-list-tile-avatar>
                </v-list-tile>
                <!-- <v-divider></v-divider> -->
              </template>
            </v-list>
          </v-flex>
          <v-flex>
            <v-layout class="h-100" justify-end align-end>
              <v-btn flat  @click="$emit('close')">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import channelMixins from '@/mixins/channels';

export default {
  mixins: [channelMixins],
  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      dialog: false,
      channels: [],
    };
  },
  methods: {
    icon(channel) {
      let icon;
      if (channel === 'email') {
        icon = 'fas fa-envelope';
      } else if (channel === 'whatsapp') {
        icon = 'fab fa-whatsapp';
      } else if (channel === 'sms') {
        icon = 'fas fa-comments';
      }
      return icon;
    },
    updateList(chatCenter) {
      const channel = this.channels.find(x => x.channel === chatCenter.channel);
      const statusOld = chatCenter.status_old;
      const statusNew = chatCenter.status;
      if (['Espera', 'Reasignado', 'Por asignar'].includes(statusOld)) {
        channel.quantity -= 1;
      } else if (['Espera', 'Reasignado', 'Por asignar'].includes(statusNew)) {
        channel.quantity += 1;
      }
    },
    pusher(dialog) {
      if (dialog) {
        window.Echo.private(`company.${this.$auth.user().company.id}.chatCenter`)
          .listen('.ChatCenterUpdated', (event) => {
            this.updateList(event.chatCenter);
          })
          .listen('.ChatCenterCreated', (event) => {
            this.updateList(event.chatCenter);
          });
      } else {
        window.Echo.leave(`company.${this.$auth.user().company.id}.chatCenter`);
      }
    },
    getInfo() {
      this.axios.get('chats_center/waiting/channel').then((res) => {
        this.channels = res.data;
        this.dialog = true;
      });
    },
  },
  watch: {
    show(show) {
      if (show) {
        this.getInfo();
      } else {
        this.dialog = show;
      }
    },
    dialog(dialog) {
      this.pusher(dialog);
      if (!dialog) this.$emit('close');
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/reports/chat_center/WaitingChannel.vue